import * as React from 'react';

import { ErrorLayout } from './ErrorLayout';
import image from '../assets/warning.png';

interface IDefaultErrorProps {
  onReload(): void;
}

export const DefaultError: React.FC<IDefaultErrorProps> = ({ onReload }) => {
  return (
    <ErrorLayout
      image={image}
      title="Неизвестная ошибка"
      description="Попробуйте обновить страницу"
      actions={[{ label: 'Перезагрузить', onClick: onReload }]}
    />
  );
};
